<template>
  <Html :lang="head.htmlAttrs.lang" :dir="dir">
    <div class="App">
      <ConfigProvider :dir="dir" teleportTo="#teleports">
        <NuxtLayout class="App-layout">
          <template v-if="banner" #banner>
            <Status
              class="PageBanner"
              :status="banner.type"
              :message="banner.message"
              :persistent="banner.persistent"
              :actionPrimary="banner.primaryAction?.label"
              :actionSecondary="banner.secondaryAction?.label"
              @click-primary="banner.primaryAction?.handler"
              @click-secondary="banner.secondaryAction?.handler"
            />
          </template>
          <NuxtPage />
        </NuxtLayout>
      </ConfigProvider>

      <Notifications />

      <BookingEngineErrorModal />

      <div id="bottom-sticky" class="u-sticky-bottom" />

      <AppFooter />
    </div>

  </Html>
</template>

<script setup lang="ts">
import { ConfigProvider } from 'reka-ui';
import Notifications from '~/components/molecules/Notifications/Notifications.vue';
import BookingEngineErrorModal from '~/components/domain/Booking/BookingEngineErrorModal.vue';
import AppFooter from '~/components/domain/Layout/AppFooter.vue';

const head = useLocaleHead();
const dir = computed<'rtl' | 'ltr'>(() => (head?.value.htmlAttrs.dir as 'rtl' | 'ltr' ?? 'ltr'));

const { banner } = useBanner();

useFeedback();
</script>
